import { useLocation, Navigate } from 'react-router-dom'

export const setUser = (username)=>(
    localStorage.setItem("username",username)
)

export const setToken = (username, token)=>{
    setUser(username)
    localStorage.setItem(username, token)
}

export const fetchToken = (token)=>{
    const username = localStorage.getItem("username")
    return localStorage.getItem(username)
}

export function RequireToken({children}){
    let auth = fetchToken()
    let location = useLocation()
    if(!auth){
        return <Navigate to='/login' state ={{from : location}}/>;
    }
    return children;
}